import React from "react";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";

/**
 * Immediate-supply acknowledgement for papers, mock exams and packs — same wording as the
 * public site's ImmediateSupplyConsent. Digital content loses the 14-day right to cancel
 * once supplied only if the buyer agreed to that here (CCR 2013 reg. 37); the API stores
 * the tick (`immediate_supply_consent`) and the refund policy reads it back.
 */
export default function ImmediateSupplyConsentCheckbox({ checked, onChange }) {
  return (
    <FormControlLabel
      sx={{ alignItems: "flex-start", mr: 0 }}
      control={
        <Checkbox checked={checked} onChange={(e) => onChange(e.target.checked)} sx={{ pt: 0.25 }} />
      }
      label={
        <Typography variant="body2">
          I want access straight away. I understand that once an item is started or downloaded,
          the 14-day right to cancel it ends, unless it is faulty.
        </Typography>
      }
    />
  );
}
